import script from "./GroupListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupListItem.vue?vue&type=script&setup=true&lang=js"

import "./GroupListItem.vue?vue&type=style&index=0&id=7aec2340&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7aec2340"]])

export default __exports__